import { createFileRoute } from "@tanstack/react-router";
import { queryClient, trpc } from "~/utils/trpc";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { ContactFormPage } from "./-pages/contactFormPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/contacts/edit/$id")({
  component: RouteComponent,
  loader: async ({ params }) => {
    const contact = await queryClient.fetchQuery(trpc.contacts.getById.queryOptions({ id: params.id }));
    return { contact };
  },
});

function RouteComponent() {
  const { contact } = Route.useLoaderData();
  useBreadCrumbs([
    { title: "Contacts", link: `/${location.pathname.split("/")[1]}/data/contacts` },
    { title: "Edit", link: `/${location.pathname.split("/")[1]}/data/contacts/edit/${contact?.id}` },
  ]);
  return <ContactFormPage contact={contact} />;
}
